import React from 'react';

const LoadingSpinner = ({ message = 'Loading…' }) => (
  <div className="ff-loading ff-loading--block" role="status" aria-live="polite">
    <span className="ff-loading__spinner" aria-hidden="true" />
    <div>
      <div className="ff-label">Please wait</div>
      <div className="ff-loading__message">{message}</div>
    </div>
  </div>
);

export default LoadingSpinner;
